export default __webpack_public_path__ + "static/media/se_iPC2.bc43d88b.jpg";